yearUtil = exports

# this should function identically to sales_year() in the PHP Year model
yearUtil.salesYear = ->
    today = new Date()

    # create a copy because the setDate() and setMonth() methods modify the
    # Date object, and we don't want to reference the object we're modifying
    useThisDate = new Date(today)
    useThisDate.setMonth( today.getMonth() + 5 )
    useThisDate.setDate( today.getDate() + 15 )

    return useThisDate.getFullYear()
